/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface SalesPlanProducts$Params {
  id: string;
}

export function salesPlanProducts(
  http: HttpClient,
  rootUrl: string,
  params: SalesPlanProducts$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<
    Array<{
      id: number;
      name: string;
    }>
  >
> {
  const rb = new RequestBuilder(rootUrl, salesPlanProducts.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<
        Array<{
          id: number;
          name: string;
        }>
      >;
    }),
  );
}

salesPlanProducts.PATH = '/api/project_calculations/sales_plan/products/{id}/';
